import React, { useEffect, useRef } from 'react';
import styles from './AcademyInNumber.module.scss';
import ScrollReveal from 'scrollreveal';
import Text from '../../../atoms/text/Text';
const backgroundImage =
  '/images/home/academy-in-numbers/academy-in-numbers.jpg';
import ImageWithBackdrop from '../../../molecule/imageWithBackdrop/ImageWithBackdrop';
import { useNavigate } from 'react-router-dom';
import useIsRtl from '../../../../app/helpers/isRtl';
import { useTranslation } from 'react-i18next';

const SECTION = 7;

const awards = '/assets/svg/academy-rating/awards.svg';
const category = '/assets/svg/academy-rating/category.svg';
const conferences = '/assets/svg/academy-rating/conferences.svg';
const credits = '/assets/svg/academy-rating/credits.svg';
const grad = '/assets/svg/academy-rating/grad.svg';
const partnerships = '/assets/svg/academy-rating/partnership.svg';
const research = '/assets/svg/academy-rating/research.svg';
const student = '/assets/svg/academy-rating/student.svg';
const workshop = '/assets/svg/academy-rating/workshop.svg';
const programs = '/assets/svg/academy-rating/programs.svg';

const dotsLine = '/assets/svg/academy-rating/dot-line.svg';

const data = [
  { number: '3', title: 'home.ranking', svg: category },
  { number: '7', title: 'home.accreditation', svg: credits },
  { number: '10', title: 'home.award', svg: awards },
  { number: '13', title: 'home.partnerships', svg: partnerships },
  { number: '12', title: 'home.researches', svg: research },
  { number: '0.5k', title: 'home.graduates', svg: grad },
  { number: '7k', title: 'home.students', svg: student },
  { number: '40', title: 'home.programs', svg: programs },
  { number: '8', title: 'home.conference', svg: conferences },
  { number: '8', title: 'home.workshops', svg: workshop },
];

const AcademyInNumber = ({ currentSection }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isRtl = useIsRtl();
  const headerRef = useRef(null);
  const contentRef = useRef(null);
  const rightRef = useRef(null);
  const buttonMobileRef = useRef(null);

  useEffect(() => {
    const srConfig = {
      delay: 100,
      duration: 500,
      easing: 'ease-in-out',
      opacity: 0,
      scale: 0.9,
      distance: '20px',
      reset: true,
    };

    if (headerRef.current) {
      ScrollReveal().reveal(headerRef.current, srConfig);
    }
    if (contentRef.current) {
      ScrollReveal().reveal(contentRef.current, srConfig);
    }
    if (rightRef.current) {
      ScrollReveal().reveal(rightRef.current, srConfig);
    }
    if (buttonMobileRef.current) {
      ScrollReveal().reveal(buttonMobileRef.current, srConfig);
    }
  }, []);

  return (
    <div
      className={`${styles['academy-in-number']} ${isRtl ? styles.rtl : ''}`}
    >
      <ImageWithBackdrop
        src={backgroundImage}
        alt="academy in numbers"
        backdropStyle={{ zIndex: -1 }}
        currentSection={currentSection === SECTION}
        scale="out"
        isAnimated
      />
      <div ref={headerRef} className={styles.header}>
        <Text
          title="home.academy_in_numbers"
          variant="text-bold-italic-40"
          style={{ textTransform: 'uppercase' }}
          className={styles['header']}
          // isLineBreak
        />
      </div>
      <div className={`${styles.academy} ${isRtl ? 'rtl' : ''}`}>
        <div className={styles.grid} role="list">
          {data.map((item, idx) => (
            <li key={`${item.title}-${idx}`} className={styles.tile}>
              <div className={styles.top}>
                <div className={styles['icon-container']}>
                  <img className={styles.icon} src={item.svg} alt="" />
                </div>
                <Text
                  title={item.number}
                  variant="text-bold-italic-50"
                  className={styles['num']}
                  color="black"
                />
                <Text
                  title={item.title}
                  variant="text-bold-italic-16"
                  className={styles['title']}
                  color="black"
                />
              </div>
              {/* <img src={dotsLine} className={styles.dash} /> */}
            </li>
          ))}
        </div>
      </div>
      <div className={styles['view-container']}>
        <button
          className={styles['view-btn']}
          onClick={() => navigate('/academy-in-number')}
        >
          <Text
            title="common.read_more"
            variant="text-bold-italic-16"
            maxLines={2}
            className={styles.btnTitle}
          />
        </button>
      </div>
    </div>
  );
};

export default AcademyInNumber;
